import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AdminLayout from "../../components/admin/AdminLayout";
import { MagnifyingGlass, Eye, PencilSimple, Prohibit } from "@phosphor-icons/react";

export default function AdminOwners() {
  const [owners, setOwners] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchOwners = async (q = "") => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/owners?search=${encodeURIComponent(q)}&limit=50`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("rs_token")}` } }
      );
      if (!res.ok) throw new Error("Failed to load owners");
      const data = await res.json();
      setOwners(data);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOwners(); }, []);
  useEffect(() => { const t = setTimeout(() => fetchOwners(search), 300); return () => clearTimeout(t); }, [search]);

  return (
    <AdminLayout>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="relative flex-1 max-w-md">
            <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-muted)]" />
            <input
              placeholder="Search by name, email, or business..."
              className="input-pop pl-9 w-full"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="text-sm text-[var(--ink-muted)]">{owners.length} results</div>
        </div>

        <div className="card-pop overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 text-left" style={{ borderColor: "var(--border)" }}>
                <th className="py-2 px-3 font-bold">Name</th>
                <th className="py-2 px-3 font-bold">Email</th>
                <th className="py-2 px-3 font-bold">Business</th>
                <th className="py-2 px-3 font-bold text-right">Outlets</th>
                <th className="py-2 px-3 font-bold text-right">Status</th>
                <th className="py-2 px-3 font-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={6} className="py-8 text-center text-[var(--ink-muted)]">Loading...</td></tr>
              )}
              {!loading && owners.length === 0 && (
                <tr><td colSpan={6} className="py-8 text-center text-[var(--ink-muted)]">No owners found</td></tr>
              )}
              {owners.map((o) => (
                <tr key={o.id} className="border-b hover:bg-gray-50 transition-colors" style={{ borderColor: "var(--border)" }}>
                  <td className="py-2.5 px-3 font-medium">{o.name}</td>
                  <td className="py-2.5 px-3">{o.email}</td>
                  <td className="py-2.5 px-3">{o.business_name}</td>
                  <td className="py-2.5 px-3 text-right">{o.outlets?.[0]?.count || 0}</td>
                  <td className="py-2.5 px-3 text-right">
                    <span className={`inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full ${o.is_disabled ? "bg-red-100 text-red-600" : "bg-green-100 text-green-600"}`}>
                      {o.is_disabled ? <Prohibit size={10} /> : null}
                      {o.is_disabled ? "Disabled" : "Active"}
                    </span>
                  </td>
                  <td className="py-2.5 px-3 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <Link to={`/admin/owners/${o.id}`} className="p-1.5 rounded hover:bg-orange-100 text-orange-600" title="View Details">
                        <Eye size={16} />
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}